import React, { useEffect, useState, FC } from "react";
import ClearDataButton from "./ClearDataButton";
import ButtonSubmit from "./ButtonSubmit";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import { UserPlusIcon } from "@heroicons/react/24/outline";

export interface GuestsInputProps {
  className?: string;
  fieldClassName?: string;
  submitLink: string;
  autoFocus?: boolean;
}

const GuestsInput: FC<GuestsInputProps> = ({
  fieldClassName = "[ nc-hero-field-padding--small ]",
  className = "",
  autoFocus = false,
  submitLink,
}) => {
  const refContainer = React.createRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState(autoFocus);
  useOutsideAlerter(refContainer, () => setIsOpen(false));

  const { guests, setGuests, showHeroSearch, setShowHeroSearch } = useHotels();

  useEffect(() => {
    if (showHeroSearch === "guests") {
      setIsOpen(true);
    }
  }, [showHeroSearch]);

  const totalGuests = guests.adults + guests.children!;

  return (
    <div className={`flex z-10 relative ${className}`} ref={refContainer}>
      <div
        className={`flex z-10 relative flex-1 text-left justify-between items-center focus:outline-none cursor-pointer ${isOpen ? "nc-hero-field-focused--2" : ""
          }`}
      >
        <div
          className={`${fieldClassName} flex-1 flex items-center gap-2`}
          onClick={() => {
            setIsOpen(!isOpen);
            setShowHeroSearch("guests");
          }}
        >
          <div className="text-neutral-500 dark:text-neutral-400">
            <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
          </div>
          <div className="flex-1 text-left">
            <span className="block font-semibold">
              {totalGuests < 2
                ? ` ${totalGuests} Hóspede`
                : ` ${totalGuests} Hóspedes`}
            </span>
            <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
              {totalGuests ? "Hóspedes" : "Adicionar hóspedes"}
            </span>
          </div>
        </div>
        <div className="relative">
          {!!totalGuests && isOpen && (
            <ClearDataButton
              onClick={() => {
                setGuests({
                  adults: 1,
                  children: 0,
                });
              }}
            />
          )}
        </div>
        <div className="pr-2">
          <ButtonSubmit href={submitLink} />
        </div>
      </div>

      {isOpen && (
        <div className="h-8 absolute self-center top-1/2 -translate-y-1/2 z-0 -left-0.5 right-10 bg-white dark:bg-neutral-800"></div>
      )}

      {isOpen && (
        <div className="absolute right-0 z-30 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl">
          <NcInputNumber className="w-full mt-6" max={10} />
        </div>
      )}
    </div>
  );
};

export default GuestsInput;
